import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet-async";
import Config from "../Config.json";
import { Link, useParams } from "react-router-dom";

import { useTranslation } from "react-i18next";
import { getArticles,subscribeToNewsletter } from "../Fetching";
import AOS from "aos";
import "aos/dist/aos.css";

const TITLE = Config.SITE_TITLE + " | Home";
const DESC =
  "This is a website application about the use of AI in everyday life.Explore the latest trends, tools, and innovations in Artificial Intelligence (AI). Our blog covers AI in everyday life, from smart technologies to AI-driven games and useful tips for using AI effectively.";

const Home = ({ category }) => {
  const formRef = useRef();
  const [message, setMessage] = useState("");
  const [messageClass, setMessageClass] = useState("hidden");
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [status, setStatus] = useState("");
  const { lng } = useParams(); // A nyelvi paraméter dinamikus kezelése
  const { t } = useTranslation(); // használjuk a useTranslation hookot a fordításhoz

  const [articles, setArticles] = useState([]);
  const fixedCategory = 0; // vagy "Machine_Learning"

  const [showCookieModal, setShowCookieModal] = useState(true);

  const categoryRoutes = {
    1: "Blog",
    2: "Machine_Learning",
    3: "AiTools",
    4: "AiGames",
    5: "HomePage",
  };

  useEffect(() => {
    const fetchData = async () => {
      console.log(
        "fetchData futott, fixedCategory:",
        fixedCategory,
        "lng:",
        lng
      );

      const allArticles = await getArticles(fixedCategory, lng);
      const homepageArticles = allArticles.filter(
        (article) => Number(article.Homepage) === 1
      );
      setArticles(homepageArticles);
    };

    fetchData();
  }, [fixedCategory, lng]);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const [showTopBtn, setShowTopBtn] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const shouldShow = window.scrollY > 300;
      setShowTopBtn(shouldShow);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email || !/^\S+@\S+\.\S+$/.test(email)) {
      setStatus("Kérlek, adj meg egy érvényes email címet.");
      return;
    }

    const result = await subscribeToNewsletter(email);
    setStatus(result.message);

    if (result.success) {
      setEmail(""); // ürítjük az inputot siker esetén
    }
  };

  /*
  useEffect(() => {
    // Cikkek lekérése a komponens betöltésekor
    Articles();
    console.log("Articles lefutott");
  }, []); // Üres függőségi lista -> csak egyszer fut le, mint a componentDidMount
  */
  useEffect(() => {
   const bootstrapScript = document.createElement("script");
bootstrapScript.src =
  "https://cdn.jsdelivr.net/npm/bootstrap@5.3.0-alpha1/dist/js/bootstrap.bundle.min.js";
document.body.appendChild(bootstrapScript);

bootstrapScript.onload = () => {
  const carouselElement = document.querySelector("#carouselExampleDark");
  if (carouselElement) {
    new window.bootstrap.Carousel(carouselElement, {
      interval: 5000,
      ride: "carousel",
    });
  }
};


    AOS.init({
      duration: 1200,
      once: true,
    });

    // Az eseménykezelők beállítása az elem létezése esetén
    const mybutton = document.getElementById("TopBtn");
    if (mybutton) {
      const scrollFunction = () => {
        if (window.scrollY > 100) {
          mybutton.style.display = "block";
        } else {
          mybutton.style.display = "none";
        }
      };

      const topFunction = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      };

      window.addEventListener("scroll", scrollFunction);
      mybutton.addEventListener("click", topFunction);

      return () => {
        window.removeEventListener("scroll", scrollFunction);
        mybutton.removeEventListener("click", topFunction);
        document.body.removeChild(bootstrapScript);
      };
    } else {
      console.error("TopBtn button not found.");
    }
  }, []);

  const validateEmail = (email) => {
    // Egyszerű email regex validáció
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  const sendEmail = async (e) => {
  e.preventDefault();

  if (!email) {
    setEmailError("Kérlek add meg az email címed!");
    return;
  }

  try {
    const response = await fetch(`${Config.API_BASE_URL}/send-email`, {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify({
    name: "Hírlevél feliratkozás",
    email: email,
    message: "Új feliratkozó a hírlevélre!"
  }),
});


    const data = await response.json();

    if (data.success) {
      setMessage("Sikeres feliratkozás! ✅");
      setMessageClass("success");
      setEmail("");
    } else {
      setMessage("Hiba történt az üzenet küldése közben ❌");
      setMessageClass("error");
    }
  } catch (error) {
    console.error("Hiba a fetch során:", error);
    setMessage("Nem sikerült csatlakozni a szerverhez ❌");
    setMessageClass("error");
  }
};


  useEffect(() => {
    // Betöltjük a particles.js-t dinamikusan
    const script = document.createElement("script");
    script.src = "https://cdn.jsdelivr.net/particles.js/2.0.0/particles.min.js";
    script.async = true;
    script.onload = () => {
      // Ha betöltődött a particles.js, meghívjuk a particlesJS funkciót
      if (window.particlesJS) {
        window.particlesJS("particles-js", {
          particles: {
            number: { value: 100 },
            size: { value: 3 },
            move: { speed: 1 },
            color: { value: "#ffffff" },
            line_linked: {
              enable: true,
              distance: 150,
              color: "#ffffff",
              opacity: 0.4,
              width: 1,
            },
          },
          interactivity: {
            detect_on: "canvas",
            events: {
              onhover: { enable: true, mode: "repulse" },
              onclick: { enable: true, mode: "push" },
            },
          },
        });
      }
    };

    document.body.appendChild(script);
  }, []);

  return (
    <main className="main-content">
      <Helmet>
        <title>AI Inside Life - Discover Artificial Intelligence Trends</title>
        <meta
          name="description"
          content="Explore how AI is changing everyday life: smart apps, AI-driven tools, and the future of artificial intelligence."
        />
        <meta name="robots" content="index, follow" />
        
        {/* Open Graph */}
        <meta property="og:title" content="AI Inside Life - Discover Artificial Intelligence Trends" />
        <meta property="og:description" content="Explore how AI is changing everyday life with smart tools and future innovations." />
        <meta property="og:url" content="https://aiinsidelife.com/en/Home" />
        <meta property="og:image" content="https://aiinsidelife.com/og-home.jpg" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="AI Inside Life - AI in Everyday Life" />
        <meta name="twitter:description" content="Smart tools, AI apps, and future AI insights." />
        <meta name="twitter:image" content="https://aiinsidelife.com/og-home.jpg" />

        {/* Strukturált adat (JSON-LD) */}
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "WebSite",
            "url": "https://aiinsidelife.com/",
            "name": "AI Inside Life",
            "potentialAction": {
            "@type": "SearchAction",
            "target": "https://aiinsidelife.com/search?q={search_term_string}",
            "query-input": "required name=search_term_string"
          }
        `}</script>
      </Helmet>
      
      {/* Hero szekció */}
      <section className="hero col-12 col-sm-12 col-md-12 col-lg-12 ">
        <h1>{t("Hero_text")}</h1>
      </section>
      {/* Cookie Consent Modal */}
      {showCookieModal && (
        <div
          className="cookie-modal"
          role="dialog"
          aria-modal="true"
          aria-labelledby="cookieModalTitle"
          aria-describedby="cookieModalDesc"
          tabIndex={-1}
        >
          <div className="cookie-modal-content">
            <h3 id="cookieModalTitle">
              {t("Cookie_Title") || "The site uses cookies"}
            </h3>
            <p id="cookieModalDesc">
              {t("Cookie_Description") ||
                "Our website uses cookies to improve the user experience. Please accept cookies for the full user experience."}
            </p>
            <div className="cookie-buttons">
              <button
                id="acceptCookies"
                className="btn btn-primary"
                type="button"
                onClick={() => setShowCookieModal(false)}
              >
                {t("Accept") || "I accept it"}
              </button>
              <button
                id="rejectCookies"
                className="btn btn-secondary"
                type="button"
                onClick={() => setShowCookieModal(false)}
              >
                {t("Reject") || "I refuse"}
              </button>
            </div>
          </div>
        </div>
      )}
      {showTopBtn && (
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="scroll-to-top"
          aria-label="Ugrás az oldal tetejére"
          title="Ugrás az oldal tetejére"
        >
          ↑
        </button>
      )}
      {/* Tartalom és jobb oldali hirdetések két oszlopos elrendezésben */}
      <div className="container mt-4 ">
        <div id="particles-js"></div>
        <div className="row">
          {/* Bal oldali tartalom - cikkek */}
          <div className="col-lg-9">
            <section className="latest-posts">
              <h2>
                <b>{t("Cim")}</b>
              </h2>

              <div
                id="carouselExampleDark"
                className="carousel carousel-dark slide my-3"
                data-bs-ride="carousel"
              >
                <div className="carousel-indicators">
                  {[...Array(6)].map((_, idx) => (
                    <button
                      key={idx}
                      type="button"
                      data-bs-target="#carouselExampleDark"
                      data-bs-slide-to={idx}
                      className={idx === 0 ? "active" : ""}
                      aria-current={idx === 0 ? "true" : undefined}
                      aria-label={`Slide ${idx + 1}`}
                    ></button>
                  ))}
                </div>
                <div className="carousel-inner">
                  {[1, 2, 3, 4, 5, 6].map((num, idx) => (
                    <div
                      key={num}
                      className={`carousel-item ${idx === 0 ? "active" : ""}`}
                      data-bs-interval="5000"
                    >
                      <img
                        src={`/carouselimages/CarouselImages${num}.png`}
                        className="d-block w-100"
                        alt={`Slide ${num}`}
                      />
                      <div className="carousel-caption d-none d-md-block">
                        <ul>
                          <li>
                            <div className="carousel-text">
                              AI Assistants (Chatbots): ChatGPT, Claude, Gemini,
                              DeepSeek, Grok
                            </div>
                          </li>
                          <li>
                            <div className="carousel-text">
                              Video Generation and Editing: Synthesia, Runway,
                              Filmora, OpusClip
                            </div>
                          </li>
                          <li>
                            <div className="carousel-text">
                              Image Generation: GPT-4o, Midjourney
                            </div>
                          </li>
                          <li>
                            <div className="carousel-text">
                              Notetakers and Meeting Assistants: Fathom, Nyota
                            </div>
                          </li>
                        </ul>
                        {/*<h1 className="text-shadow-black">
                          {t(`CarouselTitle${num}`)}
                        </h1>
                        <h5 className="text-shadow-black">
                          {t(`CarouselSubTitle${num}`)}
                        </h5> */}
                      </div>
                    </div>
                  ))}
                </div>
                <button
                  className="carousel-control-prev"
                  type="button"
                  data-bs-target="#carouselExampleDark"
                  data-bs-slide="prev"
                >
                  <span
                    className="carousel-control-prev-icon"
                    aria-hidden="true"
                  ></span>
                  <span className="visually-hidden">Előző</span>
                </button>
                <button
                  className="carousel-control-next"
                  type="button"
                  data-bs-target="#carouselExampleDark"
                  data-bs-slide="next"
                >
                  <span
                    className="carousel-control-next-icon"
                    aria-hidden="true"
                  ></span>
                  <span className="visually-hidden">Következő</span>
                </button>
              </div>

              {articles.length === 0 ? (
                <p>Nincsenek megjelenítendő cikkek.</p>
              ) : (
                articles.map((article) => (
                  <article
                    key={article.id}
                    id={`article-${article.id}`}
                    className="post post-left row mb-4 py-3 shadow"
                  >
                    <div className="col-3 image-container">
                      <img
                        className="img-fluid mt-2 mb-2 lazy-load"
                        src={
                          article.img
                            ? `/articleImages/${article.img.split("/").pop()}`
                            : "https://via.placeholder.com/300"
                        }
                        alt={article.alt || "Article Image"}
                        loading="lazy"
                      />
                    </div>
                    <div className="col-9 content-container shadow-sm rounded">
                      <div className="heading-container">
                        <div className="row">
                          <div className="col-12">
                            <h2>{article.Title}</h2>
                          </div>
                        </div>
                        {article.subtitle && (
                          <div className="row">
                            <div className="col-12">
                              <h4>{article.subtitle}</h4>
                            </div>
                          </div>
                        )}
                      </div>
                      <p>{article.Teaser}</p>
                      <Link
                        to={`/${lng}/${
                          categoryRoutes[article.category] || "Blog"
                        }`}
                      >
                        <b>{t("HomeCardLink")}...</b>
                      </Link>
                    </div>
                  </article>
                ))
              )}
            </section>
            {/* AI Eszközök */}
          </div>

          {/* Jobb oldali panel hirdetésekkel és chatbot-al */}
          <div className="col-lg-3">
            {/* Banner hirdetések */}
            {/*<section className="banners mb-4">
              <h3>Hirdetések</h3>
              <a
                href="https://www.origo.hu"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  className="img-fluid banner mt-2 mb-2"
                  src="../images/gptLogo.webp"
                  alt="Origo hirdetés"
                  loading="lazy"
                />
              </a>
              <a
                href="https://www.salgosoft.hu"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  className="img-fluid banner mt-2 mb-2"
                  src="../images/HeroLogo.webp"
                  alt="Salgosoft hirdetés"
                  loading="lazy"
                />
              </a>
            </section> */}
            {/* AI Dungeon beágyazása */}

            <section className="ai-dungeon-container">
              <h2>{t("PlayGames")}</h2>
              <iframe
                src="https://play.aidungeon.io/"
                title="AI Dungeon"
                width="100%"
                height="600px"
                style={{ border: "none" }}
              ></iframe>
            </section>
            {/*
           

            {/* Hírlevél feliratkozás */}
            <section className="newsletter container my-3 py-3">
              <h2>{t("Subscription_Title")}</h2>
              <p>{t("Subscription_SubTitle")}</p>
              <form ref={formRef} onSubmit={sendEmail} noValidate>
                <div className="form-group">
                  <label htmlFor="email">{t("Email address")}</label>
                  <input
                    type="email"
                    id="email"
                    name="email" // itt változtattam
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    className={`form-control ${emailError ? "is-invalid" : ""}`}
                    placeholder="name@example.com"
                    aria-describedby="emailHelp" // ha van segítő szöveg, pl. az emailError-hoz
                  />
                  {emailError && (
                    <div
                      id="emailHelp"
                      className="invalid-feedback"
                      style={{ display: "block" }}
                    >
                      {emailError}
                    </div>
                  )}
                </div>
                <button className="my-3 py-3" type="submit">
                  {t("Subscription_Button")}
                </button>
              </form>

              <div className={`message ${messageClass}`}>{message}</div>
            </section>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Home;
